<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import CustomPaginate from "../../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import BsLoader from "../../../../components/Loader/BsLoader.svelte";
	import client from "../../../../services/client";
	import {
		loadingStatus,
		vehicleEditData,
		loading,
	} from "../../../../store/store";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let refreshData;

	let idStatus;
	async function handleStatus(id, status) {
		try {
			idStatus = id;
			loadingStatus.set(true);
			const res = await client("/v1/photos/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id,
					status,
				},
			});
			if (res?.status === 200) {
				refreshData();
			}
		} catch (err) {
			loadingStatus.set(false);
			console.log(err);
			extractErrorMessage(err);
		}
	}

	async function handleDelete(id) {
		try {
			loading.set(true);
			const res = await client(`/v1/photos/${id}`, {
				method: "DELETE",
				version: "Vehicle",
			});
			if (res?.status === 200) {
				refreshData("delete");
				loading.set(false);
			}
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);
			extractErrorMessage(err);
		}
	}

	function handleEdit(data) {
		vehicleEditData.set(data);
		navigate(`/master-data/vehicle-data/vehicle-photos/edit/${data.id}`);
	}

	function handleImgError(i) {
		data[i].vehicleImages = ["-"];
	}
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Photos</th>
				<th>Vehicle Make</th>
				<th>Vehicle Model</th>
				<th>Vehicle Color</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, vehicleImages, vehicleMakeId, vehicleMakeName, vehicleModelId, vehicleModelName, vehicleColorId, vehicleColorName, createdAt, status }, i}
				<tr>
					<td>
						{#each vehicleImages as image}
							<img
								class="me-2"
								src={image}
								alt="car"
								on:error={() => handleImgError(i)}
								style=" height:80px;"
							/>
						{/each}
					</td>
					<td>
						<p>
							<span> {vehicleMakeName} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {vehicleModelName} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {vehicleColorName} </span>
						</p>
					</td>
					<td>
						{#if status}
							{#if $loadingStatus && idStatus == id}
								<p>&nbsp; &nbsp; <BsLoader /></p>
							{:else}
								<p class="status-bar status-bar-1">Active</p>
							{/if}
						{:else if $loadingStatus && idStatus == id}
							<p>&nbsp; &nbsp; <BsLoader /></p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							<DropdownItem
								on:click={() =>
									handleEdit({
										id,
										vehicleImages,
										vehicleMakeId,
										vehicleMakeName,
										vehicleModelId,
										vehicleModelName,
										vehicleColorId,
										vehicleColorName,
										createdAt,
										status,
									})}>Edit</DropdownItem
							>
							<DropdownItem on:click={() => handleDelete(id)}
								>Delete</DropdownItem
							>

							{#if status}
								<DropdownItem
									on:click={() => handleStatus(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() => handleStatus(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.totalCount} />
	<CustomModal />
</LoaderContainer>
